<div class="row d-flex">
  <div class="col-6 col-lg-3 mr-auto p-0">
    <h1>
      <mdb-icon fas icon="tasks"></mdb-icon> Factura de Compras a Terceros
    </h1>
  </div>
  <div class="col-6 col-lg-6 pb-1">
    <!-- COMPONENTE CARD VIEW FOLIOS -->
    <app-view-folios [codigos_dte]="codigos_dte" [contadorFacturas]="contadorFacturas"></app-view-folios>
  </div>
</div>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Compras</span>
      <span> /</span>
      <span>Factura Electrónica de Compras a Terceros</span>
    </p>
  </div>
</div>

<!-- Cabecera de botones -->
<app-factura-terceros-cabecera (onProveedorChange)="handleClienteChange($event)"
  [permiteUnidadNegocio]="permiteUnidadNegocio" [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio">
</app-factura-terceros-cabecera>

<!-- Productos -->
<app-factura-terceros-detalles (onAddProduct)="onAddProduct($event)" (onProductAdded)="onProductAdded($event)"
  [permiteUnidadNegocio]="permiteUnidadNegocio" [cabeceraComponent]="cabeceraComponent">
</app-factura-terceros-detalles>




<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">

    <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect (click)="clearFromButton()">
      Limpiar
    </button>

    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="guardar()">
      Guardar factura
    </button> -->

    <app-api-button (click2)="beginSave()" [processing]="processing">Guardar factura</app-api-button>

  </div>
</div>


<app-modal-confirm title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
</app-modal-confirm>